import { LibCategories, loadScript } from "src/utils/scriptLoader";

export function loadLiveIntent() {
  // LiveConnectTag for advertisers
  return loadScript("//b-code.liadm.com/a-037k.min.js", [
    LibCategories.performanceCookies,
  ]);
}
